export const images = {
  loginBg: require("./images/3d-render-tax-payment-financial-business-concept.jpg"),
  summaryImages: {
    totalBook: require("./images/perspective_matte-385-128x128.png"),
    sold: require("./images/perspective_matte-67-128x128.png"),
    cancel: require("./images/perspective_matte-15-128x128.png")
  },
  userProfile: require("./images/7309681.jpg"),
  bookingImage: require("./images/cherry-blossoms-fuji-mountain-spring-sunrise-shizuoka-japan.jpg"),
  logo: require("./images/logo.png")
};